import { Box, IconButton } from 'hephaestus/web';
import { LockOpen as LockOpenIcon } from 'hephaestus/webIcons';
import { type ReactNode, useId } from 'react';
import { useTranslation } from 'react-i18next';

export const useCellReleaseControl = ({
  isLocked,
  uploaded,
  releaseLabel,
  onRelease,
}: {
  isLocked?: boolean;
  uploaded?: boolean;
  releaseLabel?: string;
  onRelease?: () => void;
}) => {
  const { t } = useTranslation(['components']);
  const descriptionId = useId();

  if (!onRelease || !(isLocked || uploaded)) {
    return { describedBy: undefined, withControl: (field: ReactNode) => field };
  }

  // One row with the input: a control that wraps below it makes the row taller
  // than the grid's other rows and breaks their alignment.
  return {
    describedBy: descriptionId,
    withControl: (field: ReactNode) => (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          flexWrap: 'nowrap',
        }}
      >
        {field}
        <span id={descriptionId} hidden>
          {uploaded
            ? t('components:accountAllocationGrid.cellUploaded')
            : t('components:accountAllocationGrid.cellLocked')}
        </span>
        <IconButton aria-label={releaseLabel} size='xsmall' onClick={onRelease}>
          <LockOpenIcon fontSize='inherit' />
        </IconButton>
      </Box>
    ),
  };
};
